/* eslint-disable no-param-reassign */
import * as fabric from 'fabric';
import shapeToolCursor from '../cursors/shape_tool_cursor.svg';
import { setColor } from '../hooks/useColors';

const Shape = (canvas) => {
  canvas.freeDrawingBrush = null;
  canvas.isDrawingMode = false;

  canvas.defaultCursor = `url(${shapeToolCursor}), auto`;
  canvas.hoverCursor = `url(${shapeToolCursor}), auto`;
  canvas.moveCursor = `url(${shapeToolCursor}), auto`;
};

export const placeShape = async (canvas, shapeUrl, color) => {
  const pointerPosition = canvas.getViewportPoint();
  const initialSize = 100;

  if (shapeUrl.includes('.svg')) {
    return fabric.loadSVGFromURL(shapeUrl).then((svg) => {
      const group = new fabric.Group(svg.objects, {
        height: initialSize,
        left: pointerPosition.x / canvas.getZoom(),
        top: pointerPosition.y / canvas.getZoom(),
        width: initialSize,
      });

      group.getObjects().forEach((item) => { setColor(item, color); });

      canvas.add(group);
      canvas.setActiveObject(group);
      canvas.calcOffset();
    });
  }

  return fabric.Image.fromURL(shapeUrl, { crossOrigin: 'anonymous' }, undefined).then((img) => {
    const scaleX = initialSize / (img.width || 1);
    const scaleY = initialSize / (img.height || 1);

    const scale = Math.min(scaleX, scaleY);

    img.set({
      left: pointerPosition.x / canvas.getZoom(),
      lockUniScaling: true,
      scaleX: scale,
      scaleY: scale,
      top: pointerPosition.y / canvas.getZoom(),
    });

    img.setControlsVisibility({
      mb: false,
      ml: false,
      mr: false,
      mt: false,
    });

    canvas.add(img);
    canvas.setActiveObject(img);
  });
};

export default Shape;
